export enum EstateDetailsCollapsesTabValue {
  DETAILS = 'details',
  RELATED = 'related',
  COMMENTS = 'comments',
  AI_RESEARCH = 'ai_research',
  CLARA = 'clara'
}
